import NeighborhoodGuide from '../NeighborhoodGuideContentCard/NeighborhoodGuideContentCard';
import './NeighborhoodGuideContent.scss';
import { NeighborhoodGuideContentProps } from './NeighborhoodGuideContent.types';
import { Row } from 'react-bootstrap';

const ourFavoriteRestaurats = (
  <>
    <p>
      Any trip to London needs to have a lunch planned at <strong>Borough Market</strong> (eclectic). You will be surprised at the sheer volume of
      endless, delicious options!
    </p>
    <p>
      <strong>Padella</strong> (modern bistro) is a great place for authentic hand-made pasta at a reasonable price. Get seated at the kitchen counter
      for an up close view of the chefs at work.
    </p>
    <p>
      <strong>Elliott’s</strong> (pizza/European) is an energetic and unpretentious restaurant that sources ingredients locally from Borough Market.
      Drink selections are plentiful, but do tend to be a bit pricey.
    </p>
    <p>
      <strong>Jose Tapas</strong> (Spanish) offers authentic food and intense flavors in an intimate space that’s more conducive to eating while
      standing than it is to family dining.
    </p>
    <p>
      <strong>Indian Gourmet</strong> (Indian) Enjoy traditional cuisine from both North and South India, with plenty of gluten-free options, and a
      family-friendly atmosphere.
    </p>
  </>
);

const nightlifeWeLove = (
  <>
    <p>
      Located on the 31st floor of The Shard, Aqua Shard is a contemporary restaurant/bar that offers breathtaking, floor-to-ceiling views of London.
    </p>
    <p>
      The Swan: A truly authentic pub menu, with a good variety of pulled (on tap) beers, and a fish and chips meal served up like in the old days.
    </p>
    <p>The Distillery is a charismatic bar with a very cool vibe, great British food, and it’s dog-friendly!</p>
    <p>
      BFI Southbank’s four cinema screens show a vast selection of current and classic films, access to numerous film and TV titles and related
      materials, several food and drink options, and the Filmstore–a cinema-centric novelty shop that is definitely worth your time.
    </p>
    <p>
      Shakespeare’s Globe and The Old Vic theatres: No stay in London is complete without a visit to these legendary locales. Lovers of Shakespeare,
      theatre, history, and language will enjoy the trip back in time at the Globe, a replica of the 16th century playhouse.
    </p>
  </>
);

const theOtherGoodStuff = (
  <>
    <p>Well-insulated from the outside noise, you can sit for hours with your coffee and relax at Origin Coffee Roasters.</p>
    <p>The Table Café offers great service, and one of the best brunches in London!</p>
    <p>
      A must-see when visiting London, the wholesale and retail Borough Market has been around for almost 1000 years! A true foodie’s heaven that
      features an array of produce and specialty foods from around the world.
    </p>
  </>
);

const transitLinks = (
  <>
    <p>
      There is great connectivity to and from the South Bank, with several railway terminals within walking distance, including Waterloo, Charing
      Cross and Blackfriars.
    </p>
    <p>You’re also within walking distance of much of Central London here, over Westminster, Golden Jubilee, Waterloo, and Blackfriars bridges.</p>
    <p>
      There are taxi ranks (stands) near all the theatres and squares along South Bank. Buses are also readily available from all the main roads and
      tube stations, located at London Bridge, Waterloo East and Southwark.
    </p>
  </>
);

function NeighborhoodGuideContent({
  mainText1,
  mainText2,
  mainText3,
  favoriteRestaurants,
  nightlifeWeLove,
  theOtherGoodStuff,
  transitLinksandOtherItemsofNote
}: NeighborhoodGuideContentProps) {
  return (
    <section className="d-flex flex-column main-row">
      <section className="">
        <Row>
          <div className="neighborhood-guide-content left col-12 col-md-6">
            <div className="body-paragraph">{mainText1 && mainText1.map(child => child.children.map(text => text.text))}</div>
          </div>
          <div className="neighborhood-guide-content left d-none d-md-flex col-md-6">
            <NeighborhoodGuide header="OUR FAVORITE RESTAURANTS">
              <>{favoriteRestaurants && favoriteRestaurants.map(child => child.children.map(text => <p className="pre-wrap">{text.text}</p>))}</>
            </NeighborhoodGuide>
          </div>
        </Row>
        <Row>
          <div className="neighborhood-guide-content left d-none d-md-flex col-12 col-md-6">
            <NeighborhoodGuide header="NIGHTLIFE WE LOVE">
              <>{nightlifeWeLove && nightlifeWeLove.map(child => child.children.map(text => <p className="pre-wrap">{text.text}</p>))}</>
            </NeighborhoodGuide>
          </div>
          <div className="neighborhood-guide-content left col-12 col-md-6">
            <div className="body-paragraph">{mainText2 && mainText2.map(child => child.children.map(text => text.text))}</div>
          </div>
        </Row>
        <Row>
          <div className="neighborhood-guide-content left col-12 col-md-6">
            <div className="body-paragraph">{mainText3 && mainText3.map(child => child.children.map(text => text.text))}</div>
          </div>
          <div className="neighborhood-guide-content left d-none d-md-flex col-12 col-md-6">
            <NeighborhoodGuide header="THE OTHER GOOD STUFF">
              <>{theOtherGoodStuff && theOtherGoodStuff.map(child => child.children.map(text => <p className="pre-wrap">{text.text}</p>))}</>
            </NeighborhoodGuide>
          </div>
        </Row>
        <Row className="d-md-none">
          <div className="neighborhood-guide-content left col-12">
            <NeighborhoodGuide header="OUR FAVORITE RESTAURANTS">
              <>{favoriteRestaurants && favoriteRestaurants.map(child => child.children.map(text => <p className="pre-wrap">{text.text}</p>))}</>
            </NeighborhoodGuide>
          </div>
          <div className="neighborhood-guide-content left col-12">
            <NeighborhoodGuide header="NIGHTLIFE WE LOVE">
              <>{nightlifeWeLove && nightlifeWeLove.map(child => child.children.map(text => <p className="pre-wrap">{text.text}</p>))}</>
            </NeighborhoodGuide>
          </div>
          <div className="neighborhood-guide-content left col-12">
            <NeighborhoodGuide header="THE OTHER GOOD STUFF">
              <>{theOtherGoodStuff && theOtherGoodStuff.map(child => child.children.map(text => <p className="pre-wrap">{text.text}</p>))}</>
            </NeighborhoodGuide>
          </div>
        </Row>
      </section>
      <div className="bottom-card">
        <NeighborhoodGuide header="TRANSIT LINKS AND OTHER ITEMS OF NOTE">
          <>
            {transitLinksandOtherItemsofNote &&
              transitLinksandOtherItemsofNote.map(child => child.children.map(text => <p className="pre-wrap">{text.text}</p>))}
          </>
        </NeighborhoodGuide>
      </div>
    </section>
  );
}
export default NeighborhoodGuideContent;
